/**
 * Backend content (categories, FAQs, …) is stored per language as `<prefix>_uz`,
 * `<prefix>_ru`, `<prefix>_en`, `<prefix>_kk`. The UI language's own field is read
 * first; when it is empty we fall back to the closest language (Kazakh → Russian),
 * then to Uzbek.
 */
const CONTENT_FALLBACKS: Record<string, string[]> = {
  kk: ['ru'],
};

/** "ru-RU" → "ru"; empty → "uz". */
export const baseLanguage = (lang?: string | null): string =>
  (lang ?? '').toLowerCase().split('-')[0] || 'uz';

/** Picks `item[`${prefix}_${lang}`]` with per-language fallbacks; never returns undefined. */
export const pickLocalized = (item: object, prefix: string, lang?: string | null): string => {
  const base = baseLanguage(lang);
  const record = item as Record<string, unknown>;
  for (const code of [base, ...(CONTENT_FALLBACKS[base] ?? []), 'uz']) {
    const value = record[`${prefix}_${code}`];
    if (typeof value === 'string' && value.trim() !== '') return value;
  }
  return '';
};
